import {createContext} from "react";

export const CampaignsContext = createContext({});
export const PlacementFormDataContext = createContext({});